import { CheckListType } from "./CheckLists.types";

// Vendor Excel template layout used by CheckListImport.utils.ts - update
// here if the vendor renames a label, dropdown option, or the sheet itself.
export const CHECKLIST_IMPORT_TEMPLATE = {
  sheetName: "Import Template",

  labels: {
    checklistName: "Checklist Name *",
    description: "Description",
    checklistType: "Checklist Type *",
    na: "N/A",
    logbooks: "Logbooks *",
    tableName: "Name *",
    tableUnit: "Unit *",
  },

  checklistTypes: {
    Single: CheckListType.Single,
    "Group Item": CheckListType.GroupItem,
  } as Record<string, CheckListType>,

  naOptions: {
    Yes: true,
    No: false,
  } as Record<string, boolean>,

  units: {
    "Check Box": "check",
    "Text Input": "text",
    Header: "header",
    "Date Picker": "date",
    "Date/Time Picker": "datetime",
    "Multiple Inputs": "multiple",
  } as Record<string, string>,
};
